import React, { useCallback, useEffect, useState } from "react";
import { Loader2, Receipt, RotateCcw, Wand2 } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export const ReceiptDesign = () => {
  const [info, setInfo] = useState({ has_bg: false });
  const [pv, setPv] = useState("");
  const [busy, setBusy] = useState("");
  const load = useCallback(() => {
    api.get("/receipt-design").then((r) => setInfo(r.data)).catch(() => {});
    api.get("/receipt-preview.png", { responseType: "blob" }).then((r) => setPv(URL.createObjectURL(r.data))).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);
  const act = async (k, fn, msg) => { setBusy(k); try { await fn(); toast.success(msg); load(); } catch (e) { toast.error(apiError(e.response?.data?.detail)); } setBusy(""); };

  return (
    <Card className="glass border-gold/20 p-4 space-y-3 xl:col-span-2" data-testid="receipt-design-card">
      <p className="font-serif font-semibold text-gold flex items-center gap-2"><Receipt className="w-4 h-4" /> Money receipt design</p>
      <p className="text-xs text-emerald-100/60">Every customer payment automatically gets a money receipt with their name, amount, wallet deduction, balance, an AI thank-you note, both signatures, the company seal and the bilingual terms.</p>
      <div className="grid md:grid-cols-[1fr_260px] gap-4 items-start">
        <div className="flex flex-wrap gap-2">
          <Button size="sm" variant="outline" onClick={() => act("bg", () => api.post("/receipt-design", {}, { timeout: 180000 }), "New receipt design ready")} disabled={!!busy} data-testid="receipt-bg-create" className="border-gold/40 text-gold gap-1.5">
            {busy === "bg" ? <><Loader2 className="w-4 h-4 animate-spin" /> Designing… up to 1 min</> : <><Wand2 className="w-4 h-4" /> {info.has_bg ? "Create a new design with AI" : "Create design with AI"}</>}
          </Button>
          {info.has_bg && <Button size="sm" variant="outline" onClick={() => act("clr", () => api.delete("/receipt-design"), "Back to the classic design")} disabled={!!busy} data-testid="receipt-bg-clear" className="gap-1.5"><RotateCcw className="w-3.5 h-3.5" /> Use classic design</Button>}
        </div>
        {pv ? <img src={pv} alt="Money receipt preview" className="w-full rounded-md border border-gold/20" data-testid="receipt-preview-img" /> : <div className="aspect-[0.7] grid place-items-center"><Loader2 className="w-6 h-6 animate-spin text-gold" /></div>}
      </div>
    </Card>
  );
};
